import styled from 'styled-components';
import RecommendationLoader from 'components/productRecommendation/components/RecommendationLoader';

const StyledProductRecommendationLoader = styled(RecommendationLoader)`
    && {
        padding: 0;
    }
`;

export default StyledProductRecommendationLoader;
